import {
  QuizQuestionBlank,
  QuizQuestionBlankResponse, QuizQuestionMatchingPair, QuizQuestionSortingItem,
  QuizQuestionType,
  QuizQuestionUserBlankAnswer, QuizQuestionUserPairMatching, QuizQuestionUserItemSorting, QuizAnswerImageModel
} from "@/models/quiz.model";
import {BlankType} from "@/models/blanksInput.model";

const QUIZ_QUESTION_BASE_API = '/api/v2/quiz-questions';
const QUIZ_LABELS_NB_MAX_CHARS = 255;

const isCheckableQuestion = (type: QuizQuestionType): boolean => {
  return type === QuizQuestionType.QUESTION_CHOIX_UNIQUE || type === QuizQuestionType.QUESTION_CHOIX_MULTIPLE
      || type === QuizQuestionType.QUESTION_VRAI_FAUX;
}

const isBlanksQuestion = (type: QuizQuestionType): boolean => {
  return type === QuizQuestionType.QUESTION_FILL_IN_THE_BLANKS;
}

const isPairsMatchingQuestion = (type: QuizQuestionType): boolean => {
  return type === QuizQuestionType.QUESTION_MATCHING;
}

const isSortingQuestion = (type: QuizQuestionType): boolean => {
  return type === QuizQuestionType.QUESTION_SORTING;
}

const isMultiCheckQuestion = (type: QuizQuestionType): boolean => {
  return type === QuizQuestionType.QUESTION_CHOIX_MULTIPLE;
}

const isTextQuestion = (type: QuizQuestionType): boolean => {
  return type === QuizQuestionType.QUESTION_TEXTE || type === QuizQuestionType.QUESTION_PARAGRAPHE;
}

const isBlankAnswerCorrect = (blank: QuizQuestionBlank, realtimeBlanksAnswers: QuizQuestionUserBlankAnswer[]): boolean => {
  const userBlankResponse: QuizQuestionUserBlankAnswer | undefined = realtimeBlanksAnswers.find((blankAnswer: QuizQuestionUserBlankAnswer) => blankAnswer.blankId === blank.id);
  if (userBlankResponse) {
    if (blank.type === BlankType.TEXT) {
      const userText = userBlankResponse.textResponse || '';
      return blank.responses.some((response: QuizQuestionBlankResponse) => {
        return response.caseSensitive
            ? response.label === userText
            : response.label.toLowerCase() === userText.toLowerCase();
      });
    } else {
      const correctIds = blank.responses
          .filter((response: QuizQuestionBlankResponse) => response.correctAnswer)
          .map((response: QuizQuestionBlankResponse) => response.blankResponseId);

      return userBlankResponse.responseOptionId != null &&
          correctIds.includes(userBlankResponse.responseOptionId);
    }
  }
  return false;
}

const isPairMatchingCorrect = (pair: QuizQuestionMatchingPair, userPairsMatching: QuizQuestionUserPairMatching[]): boolean => {
  return userPairsMatching.find((userPair: QuizQuestionUserPairMatching) => userPair.itemId === pair.id)?.responseRelatedItemId === pair.id;
}

const isUserQuestionItemsSortingOrderValid = (sortingItem: QuizQuestionSortingItem, userSortedItems: QuizQuestionUserItemSorting[]): boolean => {
  return userSortedItems.find((userSortedItem: QuizQuestionUserItemSorting) => userSortedItem.itemId === sortingItem.id)?.position === sortingItem.position;
}

const questionAnswerImageExists = (answerImage: QuizAnswerImageModel | undefined): boolean => {
  if (!answerImage) {
    return false;
  }
  return !!answerImage.smallImagePath || !!answerImage.imagePath || !!answerImage.uploadTmpPath;
}

const getAnswerImagePath = (answerImage: QuizAnswerImageModel | undefined, prefereSmallVersion?: boolean) => {
  if (answerImage?.smallImagePath && prefereSmallVersion) {
    return answerImage.smallImagePath;
  }
  return answerImage?.imagePath
      || answerImage?.smallImagePath
      || answerImage?.uploadTmpPath
      || '';
}

export default {
  QUIZ_QUESTION_BASE_API,
  QUIZ_LABELS_NB_MAX_CHARS,
  isCheckableQuestion,
  isBlanksQuestion,
  isMultiCheckQuestion,
  isTextQuestion,
  isSortingQuestion,
  isBlankAnswerCorrect,
  isPairsMatchingQuestion,
  isPairMatchingCorrect,
  isUserQuestionItemsSortingOrderValid,
  questionAnswerImageExists,
  getAnswerImagePath
}
